module.exports = __webpack_public_path__ + "img/cascadia-code-light.d03837bc.png";